import { cloneElement, FC, ReactElement } from 'react'

interface MultiProviderProps { contextProviders: ReactElement[], children?: ReactElement }

const nest = (
  children: ReactElement,
  component: ReactElement
) => cloneElement(component, {}, children)

const ContextProviderComposer: FC<MultiProviderProps> = ({ contextProviders, children }) => {
  return contextProviders.reduceRight(nest, children)
}

export default ContextProviderComposer
